import React from 'react';
import {Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import Home from './components/Home';
import Heuriger from './components/Heuriger';

function App({ instance }) {
  return (
    <MsalProvider instance={instance}>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/heuriger" element={<Heuriger/>} />
      </Routes>
    </MsalProvider>
  );
}

export default App;
